import(/* webpackMode: "eager", webpackExports: ["SimulatePreloadedQuery"] */ "/app/node_modules/@apollo/client-react-streaming/dist/index.cc.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/shared/Breadcrumb/Breadcrumb.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/FindBroker/FindBroker.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/LocaleButton/LocaleButton.tsx");
